export const achievementData = {
    bio : "Putting quantified achievements on a resume is great, but I just don’t work with hard numbers. I have no data to support the quality of my work. If you have lots of relevant experience, the heading statement of your resume will be a summary.",
    achievements : [
        {
            id : 1,
            title : 'Living our values award : Optum stratathon Season 3',
            details : 'College winners and values award for optum stratathon Season 3 for formulating idea and working on model that can solve problem of medicine non-adherence',
            date : 'Aug 20, 2021',
            field : 'Automation',
            image : 'https://i.ibb.co/5M0hdbz/optum.jpg'
        },
        {
            id : 2,
            title : '4 star coder at codechef',
            details : 'solved more than 300 questions and participeted in more than 45 contests on codechef',
            date : 'present',
            field : 'Competitive coding',
            image : 'https://i.ibb.co/ct4pFPy/Screenshot-75.png'
        },
        {
            id : 3,
            title : 'Specialist at codeforces',
            details : 'solved more than 300 questions and participeted in more than 45 contests on codeforces',
            date : 'Present',
            field : 'Competitive coding',
            image : 'https://i.ibb.co/C0X1Zcm/Screenshot-76.png'
        }

    ]
}


// Do not remove any fields.
// Leave it blank instead as shown below.

/*

export const achievementData = {
    bio : "",
    achievements : []
}

*/